export class Imagens{
    urlImage1: string;
    urlImage2: string;
    urlImage3: string;
    urlImage4: string;
    urlImage5: string;
    urlImage6: string;
}